import { useState, useEffect } from "react";
import {
  Container,
  makeStyles,
  Typography,
} from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import { theme } from "../constants/theme"
import { HeaderWithButtons } from "../components-molecules";
import { CircularProggressIndicator } from "../components-atoms";
import {
  CircularProgress
} from "@material-ui/core";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import InfiniteScroll from "react-infinite-scroll-component";
import { clearSubcategoryProductsSymbols, getSubcategoryProductsSymbols, setSubcategoryPageSymbols, SUBCATEGORY_DEFAULT_ITEM_SIZE } from "../redux/actions/getSubcategoryDetails";
import { useDispatch, useSelector } from "react-redux";
import { ProductItem } from "../components-molecules";

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  searchIcon: {
    width: 24,
    height: 24,
  },
  searchIconButton: {
    width: 40,
    height: 40,
    marginLeft: 8,
    ...textButtonHoverAndActive
  },
  root: {
    flexGrow: 1,
    maxWidth: "1200px",
    padding: "24px",
  },
  mgLeftAuto: {
    display: "flex",
    flexDirection: "row",
    paddingRight: 24,
  },
  unbindButton: {
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.secondary.main,
    marginRight: "8px",
    "&:hover": {
      backgroundColor: theme.palette.secondary[16],
    },
    "&:active": {
      backgroundColor: theme.palette.secondary[32],
    },
  },

  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  selectArea: { width: "100%", marginBottom: 15 },
  primaryButton: {
    marginLeft: 8,
    borderRadius: 8,
  },
  unbinddedItem: {
    display: "flex",
    flexDirection: "row",
    paddingLeft: 15,
    paddingRight: 8,
    paddingTop: 16,
    paddingBottom: 16,
    alignItems: "center",
    "&:nth-child(2)": {
      paddingTop: 2,
    },
    "&:last-child": {
      paddingBottom: 26,
    },
  },
  unbinddedTextSection: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    marginLeft: 8,
  },
  pb4: {
    paddingBottom: 4,
  },
  productsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: '16px',
    width: '100%',
    padding: '16px 0',
  },
  title: {
    marginTop: '16px',
    marginBottom: '16px',
  },
});

export const Products = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { subcategoryId } = props;
  const page = useSelector(
    (state: any) => state.SubcategoryProductsSymbolsReducer.page
  );
  const [loading, setLoading] = useState(false);

  // Combine clear and initial load effects
  useEffect(() => {
    dispatch(clearSubcategoryProductsSymbols());
    dispatch(setSubcategoryPageSymbols(1))
    dispatch(getSubcategoryProductsSymbols(subcategoryId, 1, 10));
  }, [subcategoryId, dispatch]); // Remove page from dependencies

  const products = useSelector(
    (state: any) => state.SubcategoryProductsSymbolsReducer.data
  );

  const loadMore = () => {
    const nextPage = page + 1;
    dispatch(setSubcategoryPageSymbols(nextPage))
    dispatch(getSubcategoryProductsSymbols(subcategoryId, nextPage, SUBCATEGORY_DEFAULT_ITEM_SIZE));
  };

  // Add new useEffect to handle loading state based on Redux state
  const isLoading = useSelector(
    (state: any) => state.SubcategoryProductsSymbolsReducer.loading
  );

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  const getDataLength = () => {
    return products?.Variants?.length || 0;
  };

  return (
    <div className={classes.container}>
      <CssBaseline />
      <div className={classes.root}>
        <CssBaseline />
        <HeaderWithButtons title="Product Variants">
        </HeaderWithButtons>

        {loading && products?.Variants?.length === 0 ? (
          <>
            <CircularProggressIndicator />
          </>
        ) : products?.Variants?.length > 0 ? (
          <>
            <InfiniteScroll
              style={{ overflow: 'hidden' }}
              dataLength={getDataLength()}
              next={() => loadMore()}
              scrollThreshold={0.8}
              hasMore={getDataLength() < (products?.Total || 0)}
              loader={
                <Container style={{ width: '100%', textAlign: 'center', padding: '20px' }}>
                  <CircularProgress />
                </Container>
              }>
              <div className={classes.productsGrid}>
                {products?.Variants && Array.isArray(products.Variants) && products.Variants.map((variant) => (
                  <ProductItem key={variant.Id} variant={variant} />
                ))}
              </div>
            </InfiniteScroll>
          </>
        ) : (
          <>
            <Typography variant="body2" component="h2" className={classes.title}>
              No variants found
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};
